export default "__VITE_ASSET__CJ$tQlOG__"